module.exports = __webpack_public_path__ + "img/i5gam-mobile6.07450f9b.png";